import React, { Component, Fragment } from 'react';
import draggableContainer from '../../components/hoc/DraggableContainer';
import { Input, Button, Table, Collapse } from 'reactstrap';

import buscaFonetica from '../../utils/buscaFonetica';

const DAYS = [...Array(7).keys()];
const CustomTable = draggableContainer({
  draggableChild: "tbody"
})(Table);

const backgroundColor = value => {
  if (!value) {
    return "#B2FFB2";
  }
  if (value > 7 * 60) {
    return "#FFB2B2";
  }
  if (value > 6 * 60) {
    return "#FFFFB2";
  }
  return "inherit";
};

const formatTime = v => ("0" + Math.floor(v / 60)).slice(-2) + ":" + ("0" + Math.floor(v % 60)).slice(-2);

export default class extends Component {
  constructor (props) {
    super(props);

    this.state = {
      collapseDescricao: {},
      filtros: {
        prioridade: "",
        tarefa: "",//"Limpar Área da Portaria",
        perfil: "",//"ZELADOR_4",
        dias: [false, false, false, false, false, false, false]
      },
      toggleUpdate: false,
      ...props.value.result
    };

    this.ids_tarefa = 0;
    this.ids_perfil = 0;
  }

  toggleDescricao = tarefa => e => this.setState(({ collapseDescricao }) => ({
    collapseDescricao: {
      ...collapseDescricao,
      [tarefa.id]: !collapseDescricao[tarefa.id]
    }
  }));

  get_dias = chaveTarefa => this.state.tarefas
  .find(tarefa => tarefa.id === chaveTarefa.id_tarefa)
  .perfis
  .find(perfil => perfil.id === chaveTarefa.id_perfil)
  .dias;

  handleSave = () => {
    this.props.actions.onSaveConfigTask({ value: this.state.tarefas.map(tarefa => tarefa.perfis.map(perfil => perfil.dias)).flat(2).filter(dia => !!dia) });
  };

  handleChangeStatus = chaveTarefa => e => {
    let status = e.target.checked?1:0;

    this.setState(({ perfis, tarefas, toggleUpdate }) => {
      this.updateSingle(tarefas, chaveTarefa, "status", status, dia => {
        perfis.find(perfil => perfil.id === dia.id_perfil).dias_semana[dia.dia_semana] += dia.estimativa * (dia.status?1:-1);
      });

      return {
        toggleUpdate: !toggleUpdate
      };
    });
  };

  update = (tarefas, { id, nome, perfis, ...otherDia }, key, value, cb = () => {}) => {
    const tarefa = tarefas.find(tarefa => tarefa.id === id);
    tarefa[key] = value;
    tarefa.perfis.forEach(perfil => {
      perfil[key] = value;
      perfil.dias.forEach((dia, i) => {
        if (dia || i === otherDia.dia_semana) {
          if (!dia) {
            dia = otherDia;
            perfil.dias[i] = dia;
          }
          dia.id_tarefa = id;
          dia.nome_tarefa = tarefa.nome;
          dia.id_perfil = perfil.id;
          dia.nome_perfil = perfil.nome;
          dia[key] = value;
          cb(dia);
        }
      });
    });
  };

  updateSingle = (tarefas, { id, nome, perfis, ...otherDia }, key, value, cb = () => {}) => {
    const tarefa = tarefas.find(tarefa => tarefa.id === id);
    const perfil = tarefa.perfis.find(perfil => perfil.id === otherDia.id_perfil);

    let dia = perfil.dias.find((_d, i) => i === otherDia.dia_semana);
    if (!dia) {
      dia = otherDia;
      perfil.dias[otherDia.dia_semana] = dia;
    }
    dia.id_tarefa = id;
    dia.nome_tarefa = tarefa.nome;
    dia.id_perfil = perfil.id;
    dia.nome_perfil = perfil.nome;
    dia[key] = value;

    cb(dia);
  };

  handleEstimativa = chave => e => {
    let value = e.target.value;

    this.setState(({ tarefas, perfis, toggleUpdate }) => {
      let diff = value - chave.estimativa;

      this.update(tarefas, chave, "estimativa", value, dia => {
        if (dia.status) {
          perfis.find(perfil => perfil.id === dia.id_perfil).dias_semana[dia.dia_semana] += diff;
        }
      });

      return {
        perfis,
        toggleUpdate: !toggleUpdate
      };
    });
  };

  handleDescricao = chave => e => {
    let value = e.target.value;

    this.setState(({ tarefas, perfis, toggleUpdate }) => {
      this.update(tarefas, chave, "descricao", value);

      return {
        toggleUpdate: !toggleUpdate
      };
    });
  };

  handleFiltro = v => ({ target: { value } }) => this.setState(({ filtros }) => ({
    filtros: {
      ...filtros,
      [v]: value.replace(/^\s+|\s+(?=\s$|\s)/g, '')
    }
  }));

  handleFiltro2 = v => ({ target: { value } }) => this.setState(({ filtros }) => ({
    filtros: {
      ...filtros,
      [v]: this.padroniza(value)
    }
  }));

  handleFiltroDias = v => ({ target: { checked }}) => this.setState(({ filtros }) => {
    filtros.dias[v] = checked;

    return {
      filtros
    };
  });

  handleDragStart = task => e => {
    this.draggableTask = task;
  };

  padroniza = v => v.toUpperCase().replace(/\W+/gi, "")

  addTask = e => {
    let { filtros: { prioridade, tarefa, perfil, dias }, tarefas, perfis, filtros } = this.state;

    const nomePadraoTarefa = this.padroniza(tarefa);
    let existingTask = tarefas.find(t => this.padroniza(t.nome_tarefa) === nomePadraoTarefa);

    if (!prioridade && existingTask) {
      prioridade = existingTask.prioridade;
    } else if (!prioridade || prioridade < 1) {
      prioridade = 1;
    } else if (prioridade > tarefas.length) {
      prioridade = tarefas.length;
    }

    if (!existingTask) {
      let id_tarefa = --this.ids_tarefa;
      existingTask = {
        id: id_tarefa,
        id_tarefa,
        prioridade: 1 + tarefas.length,
        estimativa: 5,
        local_qrcode: "",
        status_qrcode: 0,
        nome_perfil: perfil,
        nome: tarefa,
        nome_tarefa: tarefa,
        descricao: "...",
        perfis: []
      };
      tarefas.push(existingTask);
    }

    const nomePadraoPerfil = this.padroniza(perfil);
    let existingPerfilTarefa = existingTask.perfis.find(p => this.padroniza(p.nome_perfil) === nomePadraoPerfil);
    let existingPerfil;
    if (existingPerfilTarefa) {
      existingPerfil = perfis.find(p => p.id === existingPerfilTarefa.id_tarefa);
    } else {
      let id_perfil = --this.ids_perfil;
      existingPerfilTarefa = {
        id: id_perfil,
        id_perfil,
        prioridade: existingTask.prioridade,
        nome: perfil,
        nome_perfil: perfil,
        dias: DAYS.map(day => ({
          status: 0,
          prioridade: existingTask.prioridade,
          descricao: existingTask.descricao,
          dia_semana: day,
          estimativa: existingTask.estimativa,
          local_qrcode: existingTask.local_qrcode,
          status_qrcode: existingTask.status_qrcode,
          nome_perfil: perfil,
          nome_tarefa: existingTask.nome_tarefa,
        }))
      };
      existingPerfil = {
        id: id_perfil,
        nome: perfil,
        dias_semana: [0, 0, 0, 0, 0, 0, 0]
      };
      perfis.push(existingPerfil);
      existingTask.perfis.push(existingPerfilTarefa);
    }
    dias.forEach((v, i) => {
      let dia = existingPerfilTarefa.dias[i];
      dia.prioridade = prioridade;
      if (v) {
        dia.status = 1;
        existingPerfil.dias_semana[i] += existingTask.estimativa;
      }
    });
    console.log(existingTask);

    filtros.perfil = "";
    filtros.dias = [false, false, false, false, false, false, false];

    this.updatePrioridades(existingTask, tarefas[prioridade - 1]);
  };

  updatePrioridades = (fromTask, toTask) => {
    this.setState(({ tarefas, toggleUpdate }) => {
      let from = fromTask.prioridade;
      let to = toTask.prioridade;

      if (1 + from === to) {  // permuta entre nós vizinhos
        console.group(tarefas[0].prioridade, tarefas[1].prioridade);
        console.log("BEFORE", tarefas[0].id_tarefa, tarefas[1].id_tarefa);

        this.update(tarefas, fromTask, "prioridade", to);
        this.update(tarefas, toTask, "prioridade", from);

        Array.prototype.splice.apply(tarefas, [from - 1, 0, ...tarefas.splice(to - 1, 1)]);

        console.log("AFTER", tarefas[0].id_tarefa, tarefas[1].id_tarefa);
        console.log("-> ", tarefas[0].prioridade, tarefas[1].prioridade);
        console.groupEnd();
      } else if (from < to) {
        console.group(tarefas[0].prioridade, tarefas[1].prioridade);
        console.log("BEFORE", tarefas[0].id_tarefa, tarefas[1].id_tarefa);

        Array.prototype.splice.apply(tarefas, [to - 1, 0, ...tarefas.splice(from - 1, 1)]);

        tarefas.slice(from - 1, to - 1).forEach(tarefa => {
          --tarefa.prioridade;
          this.update(tarefas, tarefa, "prioridade", tarefa.prioridade);
        });
        this.update(tarefas, fromTask, "prioridade", to);

        console.log("AFTER", tarefas[0].id_tarefa, tarefas[1].id_tarefa);
        console.log("-> ", tarefas[0].prioridade, tarefas[1].prioridade);
        console.groupEnd();
      } else {
        console.group(tarefas[0].prioridade, tarefas[1].prioridade);
        console.log("BEFORE", tarefas[0].id_tarefa, tarefas[1].id_tarefa);

        Array.prototype.splice.apply(tarefas, [to - 1, 0, ...tarefas.splice(from - 1, 1)]);

        tarefas.slice(to, from).forEach(tarefa => {
          ++tarefa.prioridade;
          this.update(tarefas, tarefa, "prioridade", tarefa.prioridade);
        });
        this.update(tarefas, fromTask, "prioridade", to);

        console.log("AFTER", tarefas[0].id_tarefa, tarefas[1].id_tarefa);
        console.log("-> ", tarefas[0].prioridade, tarefas[1].prioridade);
        console.groupEnd();
      }

      delete this.draggableTask;

      return {
        tarefas,
        toggleUpdate: !toggleUpdate
      };
    });
  };

  handleDrop = dropableTask => e => {
    this.updatePrioridades(this.draggableTask, dropableTask);
  };

  filterTasks = value => tarefas => tarefas.filter(tarefa => !value || -1 < buscaFonetica(tarefa.nome).indexOf(value.trim()));
  filterPerfis = value => tarefa => tarefa.perfis.filter(perfil => !value || -1 < buscaFonetica(perfil.nome).indexOf(value.trim()));
  filterPerfilPorDia = value => perfis => perfis.filter(perfil => value.every(dia => !dia) || value.every((dia, i) => !dia || (perfil.dias[i] && 1 === perfil.dias[i].status)));

  stopPropagation = e => e.stopPropagation();

  render () {
    let { filtros, tarefas, perfis, collapseDescricao } = this.state;

    let filtrosFoneticos = {
      tarefa: buscaFonetica(filtros.tarefa),
      perfil: buscaFonetica(filtros.perfil)
    };

    let filteredTasks = this.filterTasks(filtrosFoneticos.tarefa)(tarefas);
    let filterPerfil = this.filterPerfis(filtrosFoneticos.perfil);
    let filterPorDia = this.filterPerfilPorDia(filtros.dias);

    return (<Fragment>
      <div className="text-right">
        <Button color="primary" onClick={this.handleSave}><span className="fas fa-save"></span> Salvar</Button>
      </div>
      <br />
      <CustomTable size="sm">
      <thead>
        <tr>
          <th rowSpan={2}>#</th>
          <th rowSpan={2}>Tarefa</th>
          <th rowSpan={2}>Estimativa</th>
          <th rowSpan={2} className="d-none d-sm-table-cell">Perfil</th>
          <th colSpan={7} className="d-none d-lg-table-cell">Semana</th>
          <th rowSpan={2}>&nbsp;</th>
        </tr>
        <tr className="text-center d-none d-lg-table-row">
          <th>D</th>
          <th>S</th>
          <th>T</th>
          <th>Q</th>
          <th>Q</th>
          <th>S</th>
          <th>S</th>
        </tr>
        <tr className="text-center d-lg-none"></tr>
        <tr>
          <td><Input bsSize="sm" value={filtros.prioridade} onChange={this.handleFiltro("prioridade")} size="1" /></td>
          <td><Input bsSize="sm" value={filtros.tarefa} onChange={this.handleFiltro("tarefa")} /></td>
          <td>&nbsp;</td>
          <td className="d-none d-sm-table-cell"><Input bsSize="sm" value={filtros.perfil} onChange={this.handleFiltro2("perfil")} /></td>
          {DAYS.map(i => (
            <td key={i} className="text-center d-none d-lg-table-cell"><Input checked={filtros.dias[i]} type="checkbox" style={{ position: "static", marginLeft: 0 }} onChange={this.handleFiltroDias(i)} /></td>
          ))}
          <td className="d-none d-sm-table-cell"><Button disabled={filteredTasks.some(t => 0 < filterPerfil(t).length)} size="sm" color="success" onClick={this.addTask}><span className="fa fa-plus"></span></Button></td>
        </tr>
      </thead>
      {filteredTasks.map(v => {
          return (<tbody key={v.id} onDragStart={this.handleDragStart(v)} onDrop={this.handleDrop(v)}>
          {filterPorDia(filterPerfil(v))
            .map((p, j, a) => (<tr key={p.id} onClick={this.toggleDescricao(v)}>
            {!j && <Fragment>
              <td rowSpan={a.length}>{v.prioridade}</td>
              <td rowSpan={a.length}>{v.nome}</td>
              <td rowSpan={a.length}><Input type="number" bsSize="sm" value={v.estimativa} min={5} max={120} onChange={this.handleEstimativa(v)} onClick={this.stopPropagation} /></td>
            </Fragment>}
            <td className="d-none d-sm-table-cell">{p.nome}</td>
            {DAYS.map(i => {
              let day = this.get_dias({ id_tarefa: v.id, id_perfil: p.id })[i];

              return (<td key={i} className="text-center d-none d-lg-table-cell" style={{ backgroundColor: backgroundColor(perfis.find(px => px.id === p.id).dias_semana[i]) }}><Input onClick={this.stopPropagation} checked={!!day && 1 === day.status} onChange={this.handleChangeStatus({
                ...v,
                nome_tarefa: v.nome,
                nome_perfil: p.nome,
                id_tarefa: v.id,
                id_perfil: p.id,
                dia_semana: i,
              })} style={{ position: "static", marginLeft: 0 }} type="checkbox" /></td>);
            })}
            {!j && <td rowSpan={a.length}><Button outline size="sm" color="danger"><span className="fa fa-minus"></span></Button></td>}
          </tr>))}
          <Collapse tag="tr" isOpen={!!collapseDescricao[v.id]}>
            <td colSpan={4} className="d-sm-none"><Input type="textarea" value={v.descricao} onChange={this.handleDescricao(v)} /></td>
            <td colSpan={12} className="d-none d-sm-table-cell"><Input type="textarea" value={v.descricao} onChange={this.handleDescricao(v)} /></td>
          </Collapse>
          </tbody>);
      })}
      <tfoot>
        {perfis.filter(v => !filtrosFoneticos.perfil || -1 < buscaFonetica(v.nome).indexOf(filtrosFoneticos.perfil)).map((p, j, a) => (<tr key={j}>
          {!j && <td rowSpan={a.length} colSpan={3} className="d-none d-sm-table-cell">Total</td>}
          <td className="d-none d-sm-table-cell">{p.nome}</td>
          <td colSpan={2} className="d-sm-none">{p.nome}</td>
          {DAYS.map(i => {
            let value = p.dias_semana[i] || 0;
            return (<td key={i} className="text-center d-none d-lg-table-cell" style={{ backgroundColor: backgroundColor(value) }}>{formatTime(value)}</td>)
          })}
          <td>{formatTime(p.dias_semana.reduce((s, v) => s + v, 0))}</td>
        </tr>))}
      </tfoot>
    </CustomTable></Fragment>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/agenda/ListaTarefasView.js